import React from "react"
import { AuthProviderContext } from "../obj/login/AuthProvider"

function useAuth() {
  return React.useContext(AuthProviderContext)
}

export default useAuth
